import React from 'react'
import { Link } from 'react-router-dom'
import HeroImage from '../../assets/images/hero.png'
import HeroSvg from 'assets/svg/heroSvg.svg'
import styled from 'styled-components'
import Social from 'components/Drawer/Social'
import { motion } from 'framer-motion'

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: space-between;
  margin: 0;
  overflow: auto;
  padding: 0;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    padding-top: 80px;
    flex-direction: column;
    overflow: auto;
  `}
`

const LeftSide = styled.div`
  margin-left: 80px;
  width: 570px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
    margin-left: 0;
    padding: 76px 20px;
  `}
`

const Title = styled.div`
  font-size: 48px;
  font-weight: 700;
  width: 100%;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 32px;
  `}
`

const Explaination = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 23px;
  padding-top: 38px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 14px;
    padding-top: 10px;
  `}
`

const ConnectButton = styled.button`
  background-color: #804cee;
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  line-height: 21px;
  margin-top: 72px;
  outline: none;
  padding: 20px 54px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
    padding: 10px;
    margin-top: 30px;
  `}
`

const HeroImg = styled.img`
  height: 100%;
  object-fit: cover;
  width: auto;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    height: auto;
    width: 100%;
  `}
`
const SocialWrapper = styled.div`
  position: fixed;
  bottom: 3%;
  /* right: 2%; */
  left: 2%;
`

const Landing = () => {
  const FramerLeftSide = motion(LeftSide)
  const FramerWrapper = motion(Wrapper)
  return (
    <FramerWrapper initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }}>
      <FramerLeftSide>
        <Title>YOUR PORTAL TO THE GAMING METAVERSE</Title>
        <Explaination>
          Boxy is a blockchain gaming guild, bringing gamers, developers, and investors together to earn, build, and
          invest via play-to-earn based economies.
        </Explaination>
        {
          <Link to="/home">
            <ConnectButton>Start Adventure</ConnectButton>
          </Link>
        }
      </FramerLeftSide>
      <HeroImg src={HeroSvg} alt="We're Having Fun!" />
      <SocialWrapper>
        <Social />
      </SocialWrapper>
    </FramerWrapper>
  )
}

export default Landing
